/**
 * Map of models that should use vehicle lookup by brand
 */
export const modelsWithLookupByBrand = {
    finn: [
        'car-used',
        'car-used-business',
        'car-new',
        'car-leasing',
        'car-leasing-business',
        'motorcycle',
        'moped',
        'atv',
        'snowmobile',
    ],
    dba: ['car-used', 'car-used-business', 'car-new', 'car-leasing', 'car-leasing-business'],
    blocket: ['car-used', 'a-tractor', 'motorcycle'],
    bilbasen: [],
};
